import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { CatalogResponse, ChildrenCategoryResponse, ExtraTaxesResponse, MeasurementsResponse } from 'src/app/models/catalog.model';
import { ProductRequest, ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-modal-create-product',
  templateUrl: './modal-create-product.component.html',
  styleUrls: ['./modal-create-product.component.scss']
})
export class ModalCreateProductComponent implements OnInit {
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  @Input() newProduct: ProductRequest = new ProductRequest();
  @Input() productId = null;
  catalogs: CatalogResponse;
  categories: { [key: string]: ChildrenCategoryResponse[] } = {};
  measurements: { [key: string]: MeasurementsResponse[] } = {};
  extraTaxes: { [key: string]: ExtraTaxesResponse[] } = {};
  products: ProductResponse[] = [];
  filter: ProductResponse[] = [];
  @Input() exempt = "n";
  inputs = {
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  timeout = null;
  loadingImage = false;

  constructor(
    private productService: ProductService,
    private toastService: ToastrService,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit(): void {
    this.inputs.product.value = this.newProduct.idAssociated;
    this.productService.getCatalogs().subscribe({
      next: (response: ResponseObject) => {
        this.catalogs = response.data;
        var productCategories = this.catalogs.productCategories;
        productCategories.forEach(category => {
          this.categories[category.id + ""] = category.children;
        });
        var measurementCategories = this.catalogs.measurementCategories;
        measurementCategories.forEach(measurement => {
          this.measurements[measurement.id + ""] = [];
        });
        var mtemp = this.catalogs.measurements;
        for (let i = 0; i < mtemp.length; i++) {
          this.measurements[mtemp[i].category + ""].push(mtemp[i]);
        }

        if (this.newProduct.measurement) {
          try{
            const numberMeasurement = Number.parseInt(this.newProduct.measurement);
            const selectedUnit = mtemp.find(m => m.id == numberMeasurement);
            if (selectedUnit) {
              this.newProduct.measurement = selectedUnit.category + "";
              this.newProduct.measurementCategory = selectedUnit.id + "";
            }
          } catch(error){
            
          }
        
        }

        this.extraTaxes = {};

        var etemp = this.catalogs.extraTaxes || [];

        for (let i = 0; i < etemp.length; i++) {

          const key = etemp[i].extraTypeTaxId + "";

          if (!this.extraTaxes[key]) {
            this.extraTaxes[key] = [];
          }

          this.extraTaxes[key].push(etemp[i]);
        }
        if (this.newProduct.extraTaxId && this.newProduct.hasExtraTax){
          var actual = etemp.find((extra) => {
            return extra.id+"" == this.newProduct.extraTaxId;
          });
          this.newProduct.extraTaxTypeId = actual.extraTypeTaxId+"";
        }
        if (!this.newProduct.extraTaxId || !this.newProduct.hasExtraTax) {
          this.newProduct.extraTaxTypeId = null;
          this.newProduct.extraTaxId = null;
          this.newProduct.hasExtraTax = false;
        }

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
    this.productService.getProductList().subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.filter = this.products.filter(p => p.id !== this.productId);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeProduct(event: any) {
    let inputValue = event.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.productService.getProducts(inputValue).subscribe({
        next: (response: ResponseObject) => {
          this.products = response.data;
          this.filter = this.products.filter(p => p.id !== this.productId);
          if (this.filter.length == 0) {
            this.newProduct.idAssociated = null;
            this.inputs.product.class = "fa fa-xmark";
          } else if (this.filter.length == 1) {
            this.check(this.filter[0]);
          } else {
            this.newProduct.idAssociated = null;
            this.inputs.product.class = "fa-list";
          }
        },
        error: (error: HttpErrorResponse) => {
          this.newProduct.idAssociated = null;
          this.toastService.error(error.error.message);
        }
      })
    }, 500);
  }

  clean(){
    this.inputs.product.value = "";
    this.inputs.product.verified = false;
    this.inputs.product.class = "fa-list";
    this.newProduct.idAssociated = null;
  }

  check(product: ProductResponse) {
    this.inputs.product.value = product.code + " - " + product.name;
    this.inputs.product.verified = true;
    this.inputs.product.class = "fa-circle-check";
    this.newProduct.idAssociated = this.inputs.product.value;
  }

  postProduct() {
    this.newProduct.measurement = this.newProduct.measurementCategory;

    const noExtraTax = !this.newProduct.extraTaxTypeId || this.newProduct.extraTaxTypeId === '';
    if (noExtraTax) {
      this.newProduct.extraTaxTypeId = null;
      this.newProduct.extraTaxId = null;
      this.newProduct.hasExtraTax = false;
    } else {
      this.newProduct.hasExtraTax = !!this.newProduct.extraTaxId;
    }
    this.newProduct.canBeExent = this.exempt == 'p';
    this.newProduct.isExempt = this.exempt == "d";
    if (this.productId) {
      this.productService.saveChanges(this.productId, this.newProduct).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha editado correctamente el producto");
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
    } else {
      this.productService.postProduct(this.newProduct).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha guardado correctamente el producto");
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
    }
  }

  showUploadImage() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.loadingImage = true;
  }

  getDisabledSave() {
    return !this.newProduct.name || !this.newProduct.parentCategory || (this.newProduct.type == 'b' && !this.newProduct.productType)
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  uploadingImage = false;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  uploadImage() {
    if (this.uploadingImage) {
      return;
    }
    this.uploadingImage = true;
    if (this.productId) {
      this.productService.updateImageProduct(this.productId, this.croppedImage).subscribe({
        next: (response: ResponseObject) => {
          this.uploadingImage = false;
          this.newProduct.image = response.data;
          this.toastService.success("Se ha editado exitosamente la imagen del producto");
        },
        error: (error: HttpErrorResponse) => {
          this.uploadingImage = false;
          this.toastService.error(error.error.message);
        }
      });
    } else {
      this.productService.postImageProduct(this.croppedImage).subscribe({
        next: (response: ResponseObject) => {
          this.uploadingImage = false;
          this.newProduct.image = response.data;
          this.toastService.success("Se ha cargado exitosamente la imagen del producto");
        },
        error: (error: HttpErrorResponse) => {
          this.uploadingImage = false;
          this.toastService.error(error.error.message);
        }
      });
    }
  }
  onExtraTaxTypeChange(value: any) {

    if (value === null || value === '' || value === undefined) {
      this.newProduct.extraTaxTypeId = null;
      this.newProduct.extraTaxId = null;
      this.newProduct.hasExtraTax = false;
      return;
    }

    this.newProduct.extraTaxTypeId = value + '';
    this.newProduct.extraTaxId = null;
    this.newProduct.hasExtraTax = false;
  }
}
